// extracted by mini-css-extract-plugin
module.exports = {"FloorsContainer":"Floors_FloorsContainer__27F1I","Floors":"Floors_Floors__3gumj","Floor":"Floors_Floor__1LXdc","location":"Floors_location__KDAKN","active":"Floors_active__WLD5P"};